<div [class]="skinName">
    <div class="input-container">
        <form [formGroup]="changeNameForm" (ngSubmit)="changeName()" name="changeNameForm" novalidate #changeform="ngForm">
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" name="name" class="form-control" placeholder="John" formControlName="name" />
            </div>
            <div class="form-group">
                <label for="surname">Surname</label>
                <input type="text" name="surname" class="form-control" formControlName="surname" placeholder="Doe" />
            </div>
            <button class="uk-button submit-btn">{{ configService.localeKeys?.cng_pass_btn_save_cng_def}}</button>
        </form>
    </div>

</div>